import { render, staticRenderFns } from "./EggRecord.GeneralPanel.vue?vue&type=template&id=d0a2d1c6&scoped=true&"
import script from "./EggRecord.GeneralPanel.vue?vue&type=script&lang=js&"
export * from "./EggRecord.GeneralPanel.vue?vue&type=script&lang=js&"
import style0 from "./EggRecord.GeneralPanel.vue?vue&type=style&index=0&id=d0a2d1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a2d1c6",
  null
  
)

export default component.exports